import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const portfolio = [{
  id: 2,
  title: 'Platinum Ice',
  image: 'https://cdn.magicpatterns.com/uploads/f4Jdi4EB7dKeZRtxTdVi2L/⚪️🎨💈✂️_framesiurguay.webp',
  className: ''
}, {
  id: 3,
  title: 'Cyber Blue',
  image: 'https://cdn.magicpatterns.com/uploads/3pXCkBSKwPznXsZshCNdmZ/⚪️🔹🇺🇾💈.webp',
  className: ''
}, {
  id: 4,
  title: 'Blue Streak Mullet',
  image: 'https://cdn.magicpatterns.com/uploads/9GZaDTC98FDnNzDqhJDfVK/El_corte_de_tu_suenos_lo_tenes_en_barberianinja2.0_🥷🙏🏼✂️_manana_nueva_peli_📽️🎞️_roodrigos.webp',
  className: ''
}, {
  id: 5,
  title: 'Taper Fade',
  image: 'https://cdn.magicpatterns.com/uploads/46aXkGSCXftQ8X77yUYL9x/Taper_Fade_✂️_lucaaasmz_😎🔥_(1).webp',
  className: ''
}, {
  id: 6,
  title: 'Color Fantasía',
  image: 'https://cdn.magicpatterns.com/uploads/cbRFF27ZM23HSAjLsMG4ei/🔥💈_HOY_SE_VIVIO_UNA_LOCURA_💈🔥Tremendamente_agradecido_con_cada_persona_que_estuvo_presente_e.webp',
  className: ''
}];
export function ColoristShowcase() {
  return <section id="color" className="py-32 bg-[#050505]" data-id="element-105" data-mp="1t17sfzhdfayk">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-106" data-mp="1fbe4rkhlqwqf">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-107" data-mp="1f8i3bm6jppx8">
          <div data-id="element-108" data-mp="1k7l0ylk74tv6">
            <motion.h2 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="font-display text-5xl md:text-7xl mb-4" data-id="element-109" data-mp="15cetrv9d6p09">
              Especialista en{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-violet to-fuchsia-500" data-id="element-110" data-mp="2qprp4fd5cu1p">
                Color.
              </span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-gray-400 text-lg max-w-md" data-id="element-111" data-mp="2vmrusp633usa">
              Trabajos de colorimetría vibrantes, platinados impecables y
              diseños de autor que rompen las reglas.
            </motion.p>
          </div>

          <motion.a initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} href="https://www.instagram.com/barberianinja2.0" target="_blank" rel="noreferrer" className="hidden md:inline-flex px-6 py-3 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors text-sm font-medium" data-id="element-112" data-mp="37zvj78j93ka3">
            Ver más en Instagram
          </motion.a>
        </div>

        {/* Static Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-[300px] md:auto-rows-[400px]" data-id="element-113" data-mp="c1cx3deewgw7">
          {portfolio.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative rounded-3xl overflow-hidden bg-white/5 border border-white/10" data-id="element-114" data-mp="gywa69zdinmk" data-mpi={index}>
              {item.type === 'video' ? <div className="w-full h-full bg-black flex items-center justify-center" data-id="element-115" data-mp="ztb95zloqgae">
                  <video src={item.image} loop muted playsInline preload="none" width="600" height="600" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" onMouseEnter={e => e.currentTarget.play()} onMouseLeave={e => e.currentTarget.pause()} data-id="element-116" data-mp="14ogx13yne514" />
                </div> : <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" decoding="async" width="600" height="600" data-id="element-117" data-mp="1nj73vz4h29ak" />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-300" data-id="element-118" data-mp="37y0si5ol3hrr" />

              <div className="absolute bottom-6 left-6 right-6" data-id="element-119" data-mp="3310hrhgshqub">
                <div className="inline-block px-4 py-2 rounded-full bg-black/50 backdrop-blur-md border border-white/10 text-sm font-medium text-white transform translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300" data-id="element-120" data-mp="3bf58n1ak0lup">
                  {item.title}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-121" data-mp="3u7h7vf5wv70m">
          <a href="https://www.instagram.com/barberianinja2.0" target="_blank" rel="noreferrer" className="inline-flex px-6 py-3 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors text-sm font-medium w-full justify-center" data-id="element-122" data-mp="3u8scfh76kiss">
            Ver más en Instagram
          </a>
        </div>
      </div>
    </section>;
}